import { makeStyles } from '@material-ui/core';

export default makeStyles({
  headerStyle: {
    marginLeft: '15px',
    marginBottom: '20px',
  },
});
